import { compose, lifecycle, withProps } from 'recompose';
import { connect } from 'react-redux';
import {
  actions as orderActions,
  selectors as orderSelectors,
  selectorsByType,
} from 'state/order';
import { selectors as errorsSelectors } from 'state/errors';
import { selectors as warningsSelectors } from 'state/warnings';

import { methods as errorMethods } from 'utils/errors';
import { isEmpty } from 'utils/types';
import { hasAdditionalOptionsError as hasAdditionalOptionsErr } from 'utils/order';
import Summary from './Summary';
import { selectors as shipmentSelectors } from 'state/shipments';

const enhance = compose(
  connect(
    (state) => {
      const orderType = orderSelectors.getTypeOfOrder(state);
      const shipmentKeys = orderSelectors.getShipmentKeys(state) || [];
      const shipmentKey = shipmentKeys[0];
      return {
        orderType,
        shipmentKey,
        isSubmitting: selectorsByType.ui[orderType].getIsSubmitting(state),
        errors: errorsSelectors.getErrors(state),
        warnings: warningsSelectors.getWarnings(state),
        hasQuoteError: selectorsByType.quote[orderType].getQuoteError(state),
        quote: selectorsByType.quote[orderType].getQuote(state),
        isRecurring: orderSelectors.getIsRecurringOrder(state),
        address: shipmentSelectors.getShipmentAddress(
          state,
          shipmentKey,
          'dropoff'
        ),
      };
    },
    {
      handleDiscard: orderActions.discardEdition,
      fetchQuote: orderActions.fetchQuote,
    }
  ),
  withProps(({ warnings, errors, address }) => ({
    hasPastError:
      errorMethods.hasPastError(warnings) || errorMethods.hasPastError(errors),
    hasErrors: !isEmpty(errors) || !isEmpty(warnings),
    hasRecurringError: warnings.submitRecurringOrder,
    hasAditionalOptionsError: hasAdditionalOptionsErr(warnings),
    shipperInstructions: address?.poi_info?.is_booking_required
      ?.is_booking_required
      ? address?.poi_info?.shipper_instructions?.shipper_instructions || ''
      : '',
  })),
  lifecycle({
    componentDidMount() {
      const { fetchQuote } = this.props;
      fetchQuote();
    },
  })
);

export default enhance(Summary);
